// extracted by mini-css-extract-plugin
export var stepActive = "_2c-3";
export var stepCompleted = "_2c-4";
export var stepConnectorLine = "_2c-b";
export var stepIndicatorCircle = "_2c-6";
export var stepIndicatorCircleCompleted = "_2c-7";
export var stepIndicatorCircleDefault = "_2c-8";
export var stepIndicatorTextCompleted = "_2c-9";
export var stepIndicatorTextDefault = "_2c-a";
export var stepPending = "_2c-5";
export var wizardContainer = "_2c-1";
export var wizardContent = "_2c-2";
export var wizardModal = "_2c-0";